@use './breadcrumbs-common' as breadcrumbs-common;

:host {
  @include breadcrumbs-common.wb-breadcrumbs;
}

::slotted(.wb-breadcrumb) {
  @include breadcrumbs-common.wb-breadcrumbs-item;
}
